import { useTexture } from "@react-three/drei"

import paleMatcapUrl from "../../../assets/matcap_texture_light.png"
import matcapUrl from "../../../assets/matcap_texture_white.png"
import { Historical } from "../Historical"
import { Building } from "./Building"
import { Modern } from "./Modern"


export const Buildings = ({ nodes }) => {
  const matcaps = useTexture([matcapUrl, paleMatcapUrl])
  return (
    <>
      <Historical nodes={nodes} />
      <Modern nodes={nodes} matcaps={matcaps} />
      <Building name="dome" nodes={nodes} matcaps={matcaps} />
    </>
  )
}
